// Google Analytics utility functions
export const gtag = (...args) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag(...args);
  }
};

// Track page views
export const trackPageView = (pagePath, pageTitle) => {
  gtag('config', 'G-9XFNLWDFH2', {
    page_path: pagePath,
    page_title: pageTitle,
  });
};

// Track user events
export const trackEvent = (eventName, parameters = {}) => {
  gtag('event', eventName, {
    event_category: 'User Interaction',
    event_label: parameters.label || '',
    value: parameters.value || 0,
    ...parameters
  });
};

// Track login events
export const trackLogin = (method = 'email') => {
  gtag('event', 'login', {
    method: method,
    event_category: 'Authentication'
  });
};

// Track logout events
export const trackLogout = () => {
  gtag('event', 'logout', {
    event_category: 'Authentication'
  });
};

// Track user registration
export const trackSignUp = (method = 'email') => {
  gtag('event', 'sign_up', {
    method: method,
    event_category: 'Authentication'
  });
};

// Track feature usage
export const trackFeatureUsage = (featureName, action = 'use') => {
  gtag('event', 'feature_usage', {
    event_category: 'Feature',
    event_label: featureName,
    custom_parameter_1: action
  });
};

// Track navigation
export const trackNavigation = (fromPage, toPage) => {
  gtag('event', 'navigation', {
    event_category: 'Navigation',
    event_label: `${fromPage} -> ${toPage}`
  });
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  gtag('event', 'form_submit', {
    event_category: 'Form',
    event_label: formName,
    success: success
  });
};

// Track search usage
export const trackSearch = (searchTerm, searchType = 'general') => {
  gtag('event', 'search', {
    search_term: searchTerm,
    event_category: 'Search',
    event_label: searchType
  });
};

// Track file downloads
export const trackDownload = (fileName, fileType) => {
  gtag('event', 'file_download', {
    event_category: 'Download',
    event_label: fileName,
    file_type: fileType
  });
};

// Track user role and permissions
export const trackUserRole = (userRole, systemRoles) => {
  gtag('event', 'user_role_identified', {
    event_category: 'User Profile',
    member_role: userRole,
    system_roles: systemRoles.join(',')
  });
};

// Track errors
export const trackError = (errorType, errorMessage, page) => {
  gtag('event', 'exception', {
    description: `${errorType}: ${errorMessage}`,
    fatal: false,
    page: page
  });
};

// Track performance metrics
export const trackPerformance = (metricName, value, unit = 'ms') => {
  gtag('event', 'timing_complete', {
    name: metricName,
    value: value,
    event_category: 'Performance',
    unit: unit
  });
};
